<template>
  <div>
    <BaseHeadline :showOnMobile="true" icon="mdi-script-text-outline">
      <template v-slot:headlineBtns>
        <v-menu
          v-if="!$vuetify.breakpoint.mobile"
          offset-y
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-3 mb-0" color="primary" v-bind="attrs" v-on="on">
              Sorter
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, index) in sortDataTest"
                :key="index"
                @click="sortSelected(item)"
                :class="{ itemIsActive: item.selected }"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-icon>
                  <v-icon :color="item.sortDesc ? 'primary' : 'grey'">
                    mdi-arrow-down
                  </v-icon>
                  <v-icon :color="item.sortDesc === false ? 'primary' : 'grey'">
                    mdi-arrow-up
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </template>
    </BaseHeadline>

    <v-row v-if="!loading" class="mt-3 mb-7">
      <v-col
        v-for="(item, index) in dataSorted"
        :key="index"
        cols="12"
        sm="6"
        lg="4"
        xl="3"
      >
        <Card
          :number="item.meetingNumber"
          :title="item.meetingName"
          color="listHighlight"
          @click="getMinutes(item)"
        >
          <template v-slot:chips>
            <v-chip class="mr-2" small>
              {{ item.meetingTypeString }}
            </v-chip>

            <div>{{ item.meetingStart | moment("DD.MM.YYYY") }}</div>
          </template>
        </Card>
      </v-col>
    </v-row>
    <v-row v-if="loading" class="mt-3">
      <v-col v-for="index in 4" :key="index" sm="6" lg="4" xl="3">
        <Card :loading="true" />
      </v-col>
    </v-row>
    <BottomSortDialog
      v-model="openSortDialog"
      :data="sortDataTest"
      @click="sortSelected"
    />
    <v-fab-transition>
      <v-btn
        v-show="$vuetify.breakpoint.mobile"
        class="btnPsiCenter"
        color="primary"
        fixed
        @click="openSortDialog = true"
      >
        <v-icon left>mdi-swap-vertical</v-icon>
        Sorter
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import projectApi from "@/api/projectApi";
import saveFile from "@/helpers/saveFile";
import { sortObject } from "@/types/tableInterface";
import { sortArrayObject } from "@/helpers/sort";

import Card from "@/components/projects/project/minutes/children/Card.vue";
import BottomSortDialog from "@/components/shared/overview/BottomSortDialog.vue";
export default Vue.extend({
  data: () => ({
    loading: true,
    data: [],
    openSortDialog: false,
    sortBy: "meetingName" as null | string,
    sortDesc: true as null | boolean,
    sortData: [
      {
        name: "Navn",
        sortBy: "meetingName",
      },
      {
        name: "Nummer",
        sortBy: "meetingNumber",
      },
      {
        name: "Dato",
        sortBy: "meetingStart",
      },
    ] as Array<sortObject>,
  }),
  async mounted() {
    await this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;

      projectApi
        .getProjectMinutes(this.$route.params.id)
        .then((response) => {
          this.data = response;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async getMinutes(minute) {
      var data = {
        minute: minute,
        minuteRegistrations: [],
        participants: [],
        projAberrations: [],
        recipients: [],
      };

      await projectApi.previewMinute(data).then((response) => {
        saveFile(response);
      });
    },
    sortSelected(item) {
      this.sortData;
      this.sortBy = item.sortBy;
      this.sortDesc = item.sortDesc ? !item.sortDesc : true;
    },
  },
  computed: {
    dataSorted() {
      return sortArrayObject(
        this.data,
        this.sortBy,
        this.sortDesc !== null ? this.sortDesc : true
      );
    },
    sortDataTest(): Array<sortObject> {
      if (this.sortBy && this.sortDesc !== null) {
        this.sortData.forEach((x) => {
          if (x.sortBy === this.sortBy) {
            this.$set(x, "selected", true);
            this.$set(x, "sortDesc", this.sortDesc);
          } else {
            this.$set(x, "selected", false);
            this.$set(x, "sortDesc", null);
          }
        });
        return this.sortData;
      }
      return [];
    },
  },

  components: {
    BaseHeadline,
    Card,
    BottomSortDialog,
  },
});
</script>

<style lang="scss" scoped>
.btnPsiCenter {
  z-index: 2;
  left: 50%;
  bottom: calc(50px + env(safe-area-inset-bottom));
  transform: translate(-50%, -50%);
}
</style>
